import {
    SET_PLAN_MANAGE_SEARCH,
    SET_PLAN_DATA_ROW,
    SET_PLAN_DASHBOARD_DATA,
    SET_PLAN_DASHBOARD_SEARCH,
} from "../actions/types";
import { toStringDateTimeExternal } from './../helpers/date';

const tomorrow = toStringDateTimeExternal(new Date(new Date().setHours(0, 0, 0, 0) + 86400000))/*tomorrow*/

const initialState = {
    manageSearch: {
        date: tomorrow, plant: null, product: null, transport: null, type: null, hasChange: false,
        search: {
            submit: false, date: tomorrow, plant: null, product: null, transport: null, type: null
        }
    },
    dataRow: null,
    dashboardData: { time: null, plant: null, product: null, area: null, point: null, items: [], hasChange: false },
    dashboardSearch: { plant: null, product: null, area: null, point: null }
};

const PlanManagementReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_PLAN_MANAGE_SEARCH:
            return { ...state, manageSearch: payload };

        case SET_PLAN_DATA_ROW:
            return { ...state, dataRow: payload };

        case SET_PLAN_DASHBOARD_DATA:
            return { ...state, dashboardData: payload };
        
        case SET_PLAN_DASHBOARD_SEARCH:
            return { ...state, dashboardSearch: payload };

        default:
            return state;
    }
};

export default PlanManagementReducer;